// extracted by mini-css-extract-plugin
export var icon = "_4k-1";
export var subtext = "_4k-0";